import { useContext } from "react";

import { SidebarNavContext } from "./SidebarNavContext";

export const useSidebarNav = () => {
  const context = useContext(SidebarNavContext);
  if (context === undefined) {
    // Return default values for test scenarios or when context is not available
    return {
      isCollapsed: false,
      setIsCollapsed: () => {},
      toggleSidebar: () => {},
    };
  }
  return context;
};
